.wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn:hover + [role="tooltip"],
.btn:focus-visible + [role="tooltip"] {
  opacity: 1;
  pointer-events: auto;
}

.btn {
  composes: controlBtn from '../styles/controls.module.css';
}

.iconExit {
  display: none;
}

.fs .iconEnter {
  display: none;
}

.fs .iconExit {
  display: block;
}

